// extracted by mini-css-extract-plugin
export default {"Suggestions_focused":"Suggestions_Suggestions_focused__p9BgQ","Suggestions":"Suggestions_Suggestions__Xm5Uz"};